import store from '..'
import axios from 'axios'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
    controls: [],
    items: []
  },
  mutations: {
  },
  actions: {
    async getControl ({ state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-control',
          func: 'get-space-type-info',
          id: store.state.authentication.requestId
        })
        state.controls = res.data.message
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async delSubtype ({ state, dispatch }, data) {
      const updateData = state.controls.find(x => x.spacetypeid === data.spacetype)
      const updateSubtype = updateData.property
      updateSubtype.subtype = updateSubtype.subtype.concat(data.subtype).filter(x => !updateSubtype.subtype.includes(x) || !data.subtype.includes(x))
      dispatch('updateControl', {
        spacetype: data.spacetype,
        data: updateSubtype
      })
    },
    async updateControl ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-control',
          func: 'update-spacetype',
          id: store.state.authentication.requestId,
          spacetypeid: data.spacetype,
          property: data.data
        })
        return res.data.message
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async delControl ({ state }, spacetype) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-control',
          func: 'delete-spacetype',
          id: store.state.authentication.requestId,
          spacetypeid: spacetype
        })
        return res.data.message
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async delControls ({ state, dispatch }, data) {
      return Promise.all(
        data.map(x => x.subtype.includes('0')
          ? dispatch('delControl', x.spacetype)
          : dispatch('delSubtype', x))).then((res) => {
        return res
      })
    },
    async getSpaceType ({ state }, data) {
      const file = data.subtype === '0' ? `control/${data.spacetype}.json` : `control/${data.spacetype}/${data.subtype}.json`
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: file
        })
        return res.data.message
      } catch (ex) {
        // console.error('error:', ex)
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async setSpaceType ({ state }, data) {
      try {
        const file = data.subtype === '0' ? `control/${data.spacetype}.json` : `control/${data.spacetype}/${data.subtype}.json`
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.SET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: file,
          data: JSON.stringify(data.data)
        })
        return res.data.message
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    }
  },
  getters: {
    ctrlList: (state) => state.controls
  }
}
